var id = Math.floor(Math.random() * 10000);
export default function uniqueId() {
  id += 1;
  return id;
}


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/postmessage/lib/esm/uniqueId.js
// module id = 654
// module chunks = 0 1